import React from 'react';
import { HyperButton, IconHelp, Tooltip } from '@noths/polaris-client-ribbons-design-system';

import { MADE_TO_ORDER_COPY, MADE_TO_ORDER_INFO, MADE_TO_ORDER_LABEL } from '../constants/copy';
import * as styles from '../styles/ProductInfo.styles';

export const MadeToOrder = () => (
  <div css={styles.madeToOrder}>
    <p css={styles.madeToOrderLabel}>{MADE_TO_ORDER_LABEL}</p>
    <Tooltip alignment="right" content={MADE_TO_ORDER_COPY}>
      {({ onClick }) => (
        <HyperButton onClick={onClick}>
          <span css={styles.tooltipInfo}>
            {MADE_TO_ORDER_INFO}
            <IconHelp css={styles.tooltipInfoIcon} width={16} height={16} />
          </span>
        </HyperButton>
      )}
    </Tooltip>
  </div>
);
